export default __webpack_public_path__ + "static/media/2.df3fbd6b.jpg";